<mat-toolbar class="titulopartes">Documentos</mat-toolbar>
<!-- Apresenta CPF -->
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill *ngIf="apresentaCPF">
    <!-- CPF -->
    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput 
               [(ngModel)]="pessoaFisica.cpf" 
               name="cpf" 
               placeholder="CPF:"
               [textMask]="{mask: mascaraCpf}"
               [cpfValidator]
               *ngIf="!validaCPF">

        <input matInput 
               [(ngModel)]="pessoaFisica.cpf" 
               name="cpf" 
               placeholder="CPF:" 
               [textMask]="{mask: mascaraCpf}"
               [cpfValidator] 
               [required]=validaCPF
               *ngIf="validaCPF">

         <mat-error >Informa apenas valores numéricos</mat-error>  
    </mat-form-field>
    
    <!-- NIS -->
    <mat-form-field fxFlex="30%">
        <input matInput [(ngModel)]="pessoaFisica.nis" name="NIS / PIS" placeholder="NIS / PIS" [textMask]="{mask: mascaraNIS}">
    </mat-form-field>
</div>

<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput maxlength="30" [(ngModel)]="pessoaFisica.identidade" name="identidade" placeholder="Identidade">
    </mat-form-field>

    <mat-form-field fxFlex="30%">
        <input matInput [(ngModel)]="pessoaFisica.orgaoCi" name="orgaoCi" maxlength="45" placeholder="Órgão Expedidor">
    </mat-form-field>

    <mat-form-field fxFlex="5%">
        <mat-label>UF:</mat-label>
        <mat-select [(ngModel)]="pessoaFisica.ufCi" name="ufCi">
            <mat-option *ngFor="let m of ufs" [value]="m">
                {{m}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex="22%">
        <input matInput name="dataEmissaoCI" [matDatepicker]="dataEmissaoCI" 
               placeholder="Data de Emissão"
               (input)="onMascaraDataInput($event)"
               [(ngModel)]="pessoaFisica.dataEmissaoCI">
        <mat-datepicker-toggle matSuffix [for]="dataEmissaoCI"></mat-datepicker-toggle>
        <mat-datepicker #dataEmissaoCI></mat-datepicker>
    </mat-form-field>
</div>

<!-- Não apresenta CPF -->
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill *ngIf="!apresentaCPF">
    <!-- NIS -->
    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput [(ngModel)]="pessoaFisica.nis" name="NIS / PIS / NIT" placeholder="NIS / PIS / NIT" [textMask]="{mask: mascaraNIS}">
    </mat-form-field>

    <mat-form-field fxFlex="30%">
        <input matInput maxlength="30" 
               [(ngModel)]="pessoaFisica.numeroPisPasep" name="numeroPisPasep"
               placeholder="Número do PASEP">
    </mat-form-field>
</div>

<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput maxlength="15" [(ngModel)]="pessoaFisica.tituloEleitor" name="tituloEleitor"
            placeholder="Titulo de Eleitor">
    </mat-form-field>
    <mat-form-field fxFlex="30%">
        <input matInput maxlength="15" [(ngModel)]="pessoaFisica.zonaTitulo" name="zonaTitulo" placeholder="Zona">
    </mat-form-field>

    <mat-form-field fxFlex="30%">
        <input matInput maxlength="15" [(ngModel)]="pessoaFisica.sessaoTitulo" name="sessaoTitulo" placeholder="Sessão">
    </mat-form-field>

</div>


<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput maxlength="12" [(ngModel)]="pessoaFisica.numeroReservista" name="numeroReservista"
            placeholder="Número do certificado de reservista">
    </mat-form-field>

    <mat-form-field fxFlex="8%">
        <mat-label>UF:</mat-label>
        <mat-select [(ngModel)]="pessoaFisica.ufRegiaoMilitar" name="ufRegiaoMilitar">
            <mat-option *ngFor="let m of ufs" [value]="m">
                {{m}}
            </mat-option>
        </mat-select>
    </mat-form-field>

</div>


<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput maxlength="20" [(ngModel)]="pessoaFisica.numeroCNH" name="numeroCNH"
            placeholder="Número da CNH">
    </mat-form-field>

    <mat-form-field fxFlex="10%">
        <input matInput maxlength="2" [(ngModel)]="pessoaFisica.categoriaCNH" name="categoriaCNH"
            placeholder="Categoria da CNH">
    </mat-form-field>

    <mat-form-field fxFlex="25%">
        <input matInput name="vencimentoCNH" [matDatepicker]="vencimentoCNH" 
               placeholder="Data de vencimento da CNH"
               (input)="onMascaraDataInput($event)"
               [(ngModel)]="pessoaFisica.vencimentoCNH">
        <mat-datepicker-toggle matSuffix [for]="vencimentoCNH"></mat-datepicker-toggle>
        <mat-datepicker #vencimentoCNH></mat-datepicker>
    </mat-form-field>

</div>

<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput maxlength="20" [(ngModel)]="pessoaFisica.cts" name="cts"
            placeholder="Número da carteira de trabalho">
    </mat-form-field>

    <mat-form-field fxFlex="20%">
        <input matInput maxlength="15" [(ngModel)]="pessoaFisica.serieCtps" name="serieCtps"
            placeholder="Número da Série:">
    </mat-form-field>

    <mat-form-field fxFlex="10%">
        <mat-label>UF</mat-label>
        <mat-select [(ngModel)]="pessoaFisica.ufCTS" name="ufCTS">
            <mat-option *ngFor="let m of ufs" [value]="m">
                {{m}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>